"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");

const Renderer = require("./GroupingRenderer");

class GroupingComponent extends EventEmitter {
    constructor(options) {
        super();

        this._entityGrid = _.get(options, "entityGrid");

        this._groupBy = undefined;
        this._groupingColumns = [];

        this._renderer = new Renderer(this);

        this._registerListeners();
        //this._setGroupingFields(this._columnsConfig);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _triggerUserChangeGrouping(fieldName) {
        this.emit("UserChangeGrouping", fieldName, this._groupBy);
    }
    _triggerSetGroupingFields(fields) {
        this.emit("SetGroupingFields", fields);
    }
    _triggerSetGroupingValue(value) {
        this.emit("SetGroupingValue", value);
    }

    _registerListeners() {
        this._entityGrid.addListener(
            "Columns",
            (this._onColumnsChange = this._onColumnsChange.bind(this))
        );
        this._entityGrid.addListener(
            "GroupingChanged",
            (this._onGroupingChanged = this._onGroupingChanged.bind(this))
        );
    }
    _unregisterListeners() {
        this._entityGrid.removeListener("Columns", this._onColumnsChange);
        this._entityGrid.removeListener("GroupingChanged", this._onGroupingChanged);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRootElement() {
        return this._renderer.getRootElement();
    }
    getRenderer() {
        return this._renderer;
    }
    render() {
        return this._renderer.render();
    }

    shutdown() {
        this._unregisterListeners();
        const shutDowns = [this._renderer?.shutdown() || Promise.resolve()];

        return Promise.all(shutDowns).then(
            () => {
                this._renderer = undefined;
            },
            (/*err*/) => {}
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onColumnsChange(columns) {
        this._setGroupingFields(columns);
    }

    _onGroupingChanged({groupBy} = {}) {
        this.setGroupByValue(groupBy);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _setGroupingFields(columns) {
        const isGroupable = (value, key) =>
            (_.get(value, "groupable") || _.get(value, "context.groupable")) &&
            key !== this._groupBy;
        const groupableColumns = _.pickBy(columns, isGroupable);
        this._groupingColumns = groupableColumns;
        this._triggerSetGroupingFields(groupableColumns);
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    userChangeGrouping(value) {
        this._triggerUserChangeGrouping(value);
        this._groupBy = value;
    }

    updateGroupingFields() {
        const gridColumns = this._entityGrid.getColumns();
        this._setGroupingFields(gridColumns);
    }

    getGroupByValue() {
        return this._groupBy;
    }

    setGroupByValue(value) {
        if (this._groupBy !== value) {
            value = _.has(this._groupingColumns, value) ? value : undefined;
            this._groupBy = value;
            this._triggerSetGroupingValue(value);
        }
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = GroupingComponent;
